import { Dialog } from '@factorialco/f0-react/dist/experimental'
import { Delete } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

type Props = {
  open: boolean
  onClose: () => void
  onDelete: (index: number, sectionIndex: number | undefined) => void
  index: number
  sectionIndex: number | undefined
}

const DeleteDialog = ({ open, onClose, onDelete, index, sectionIndex }: Props) => {
  return (
    <Dialog
      onClose={onClose}
      open={open}
      actions={{
        primary: {
          icon: Delete,
          label: i18n.t('forms.editor.delete_dialog.remove_action'),
          onClick: () => {
            onDelete(index, sectionIndex)
          },
          variant: 'critical',
        },
        secondary: {
          label: i18n.t('forms.editor.delete_dialog.cancel_action'),
          onClick: onClose,
        },
      }}
      header={{
        description: i18n.t('forms.editor.delete_dialog.message'),
        title: i18n.t('forms.editor.delete_dialog.title'),
        type: 'critical',
      }}
    />
  )
}
export default DeleteDialog
